import { render, staticRenderFns } from "./roles-page.vue?vue&type=template&id=59c83595&scoped=true&"
import script from "./roles-page.vue?vue&type=script&lang=js&"
export * from "./roles-page.vue?vue&type=script&lang=js&"
import style0 from "./roles-page.vue?vue&type=style&index=0&id=59c83595&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c83595",
  null
  
)

export default component.exports